export const knowledgeBaseHomepageLink = 'https://help.brandfolder.com/hc/en-us';
export const userPermissionsLink = 'https://help.brandfolder.com/hc/en-us/articles/115002602273-User-Permissions';
